<template>
  <BaseTable>
    <thead>
      <tr>
        <th>Date</th>
        <th>Description</th>
        <th>Type</th>
        <th>Amount</th>
        <template v-for="(num, key) in project.facility.loans">
          <th :key="key">
            {{ $_.upperFirst($formatting.toOrdinal(key + 1)) }} Loan Balance
          </th>
        </template>
        <th>Balance Drawn</th>
        <th>Balance Undrawn</th>
        <th>Interest Accrued</th>
        <th>Interest Owed</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(date, day) in facility.schedule">
        <tr v-for="(item, index) in date.items" :key="day.toString() + index.toString()">
          <td>{{ $dates.toDate(date.date) }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.type }}</td>
          <td>{{ $formatting.toCurrency(item.amount.toFixed(2)) }}</td>
          <template v-for="(num, key) in project.facility.loans">
            <td :key="key">
              {{ item.balances[key].toFixed(2) }}
            </td>
          </template>
          <td>{{ $formatting.toCurrency(item.statement.balanceDrawn.toFixed(2)) }}</td>
          <td>{{ $formatting.toCurrency(item.statement.balanceUndrawn.toFixed(2)) }}</td>
          <td>{{ $formatting.toCurrency(item.statement.interestAccrued.toFixed(2)) }}</td>
          <td>{{ $formatting.toCurrency(item.statement.interestOwed.toFixed(2)) }}</td>
        </tr>
      </template>
    </tbody>
  </BaseTable>
</template>

<script>
import { mapState } from 'vuex'

import BaseTable from './BaseTable.vue'
import StatRow from './StatRow.vue'

export default {
  name: 'FacilitySchedule',

  components: {
    BaseTable,
    StatRow
  },

  props: {
    facility: Object
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  }
}
</script>
